// @ts-nocheck
import { connect } from 'react-redux'
import {
  getCarrierChecklist,
  getCarrierUploadedDocs,
  editCarrierChecklist,
  uploadCarrierDocuments,
  addDocUpload,
  deleteDocUpload,
} from 'utils/actions/carrier'
import { showChecklistDialog, closeChecklistDialog } from '../../../utils/actions/ui'
import { Checklists } from './Checklist'

const DocumentChecklist = connect(
  state => {
    const {
      carrier: {
        carrierDetails: { id: carrierId },
      },
      carrierDocumentsCheckLists: {
        checklists,
        opsCarrierChecklistErrors,
        opsCarrierChecklistLoading,
        updateError,
      },
      carrierDocumentsUploads: { dialogDocuments, documents, error, loading },
      ui: { checklist: checklistDialog },
    } = state
    return {
      checklists,
      opsCarrierChecklistLoading,
      opsCarrierChecklistErrors,
      updateError,
      carrierId,
      documents,
      loading,
      error,
      checklistDialog,
      dialogDocuments,
    }
  },
  dispatch => ({
    getChecklists: id => dispatch(getCarrierChecklist(id)),
    getUploadedDocs: id => dispatch(getCarrierUploadedDocs(id)),
    editCarrierChecklist: (id, opsCarrierChecklist) =>
      dispatch(editCarrierChecklist(id, opsCarrierChecklist)),
    showChecklistDialog: () => dispatch(showChecklistDialog()),
    closeChecklistDialog: () => dispatch(closeChecklistDialog()),
    uploadCarrierDocuments: (id, documents) => dispatch(uploadCarrierDocuments(id, documents)),
    addDocUpload: files => dispatch(addDocUpload(files)),
    deleteDocUpload: id => dispatch(deleteDocUpload(id)),
  })
)(Checklists)

export default DocumentChecklist
